import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { injectIntl, intlShape } from 'react-intl';
import { PropTypes } from 'prop-types';
import memoizeOne from 'memoize-one';
import PortalCommunication from '../../portal-comms';
import withLoader from '../../components/with-loader';
import Header from '../../components/header';
import DefaultCourses from '../../components/default-courses';
import messages from './messages';
import { getMasterCoursesCountries,
    getCoursesRequest,
    saveDefaultCoursesRequest } from './actions';
import { SetDefaultCoursesWrapper } from './styled';
import {
    DROPDOWN_DEFAULT_COUNTRY,
    DROPDOWN_DEFAULT_COUNTRY_LONG,
    DEFAULT_PRODUCT_ID,
    COUNTRY_ACCESS_STATUS,
    STATE_ACCESS_STATUS,
    COURSE_MANAGER_LANDING_SCREEN,
    DEFAULT_COURSE_ID } from '../../constants';
import { getDefaultCourses } from '../default-courses/actions';
import { showToast } from '../../components/toast/actions';
import { getProductList } from '../../helpers/utils';

export class SetDefaultCourses extends Component {
    static propTypes = {
        intl: intlShape.isRequired,
        getMasterCoursesCountries: PropTypes.func,
        getCoursesRequest: PropTypes.func,
        saveDefaultCoursesRequest: PropTypes.func,
        showToast: PropTypes.func,
        getDefaultCourses: PropTypes.func,
        genericCourses: PropTypes.array,
        defaultCourses: PropTypes.object,
        dataSaved: PropTypes.bool,
        saveSuccessful: PropTypes.bool,
        countries: PropTypes.oneOfType([
            PropTypes.array.isRequired,
            PropTypes.object.isRequired
        ]),
        years: PropTypes.array.isRequired
    };

    static defaultProps = {
        countries: [],
        genericCourses: []
    };

    constructor(props) {
        super(props);
        this.updatedDefaultCourses = [];
        this.isSaved = true;
        this.defaultCourses = [];
        this.years = [];
        this.selectedCountry = DROPDOWN_DEFAULT_COUNTRY;
        this.country = DROPDOWN_DEFAULT_COUNTRY_LONG;
        this.accessStatus = COUNTRY_ACCESS_STATUS;
        this.hasCountryChanged = false;
        this.hasProductChanged = false;
        this.hasStateChanged = false;
        this.allowBack = true;
        this.products = getProductList();
        this.state = {
            filters: {
                defaultCountry: DROPDOWN_DEFAULT_COUNTRY
            },
            defaultCourses: props.defaultCourses,
            filteredCourses: [],
            productId: DEFAULT_PRODUCT_ID,
            selectedState: ''
        };
        if (!props.countries.length) {
            props.getMasterCoursesCountries();
        }
        if (!props.genericCourses.length) {
            props.getDefaultCourses(this.state.productId);
            this.props.getCoursesRequest(this.accessStatus, DROPDOWN_DEFAULT_COUNTRY, this.state.selectedState, this.state.productId);
        }
        this.onDefaultCourseChange = this.onDefaultCourseChange.bind(this);
        this.setCountry = this.setCountry.bind(this);
        this.handleOnSave = this.handleOnSave.bind(this);
        this.setDefaultCourse = this.setDefaultCourse.bind(this);
        this.handleBackButton = this.handleBackButton.bind(this);
        this.handleOnProductSelect = this.handleOnProductSelect.bind(this);
        this.handleOnStateSelect = this.handleOnStateSelect.bind(this);
    }

    componentDidMount() {
        this.props.getCoursesRequest(this.accessStatus, DROPDOWN_DEFAULT_COUNTRY, this.state.selectedState, this.state.productId);
    }

    componentWillReceiveProps(nextProps) {
        this.setState({ filteredCourses: nextProps.genericCourses });

        this.defaultCourses = nextProps.defaultCourses;
        this.isSaved = nextProps.dataSaved;

        const selectedCountry = nextProps.countries.items.find(item => item.code === this.selectedCountry);
        this.getYearGroup(selectedCountry);

        const { saveSuccessful, years } = nextProps;
        this.updatedDefaultCourses = years.map((y) => {
            const courseId = this.defaultCourses[Number(y.id)] && this.defaultCourses[Number(y.id)].courseId;
            return ({
                yearGroupEnum: y.id,
                courseId: (courseId === undefined || courseId === null) ? DEFAULT_COURSE_ID : courseId
            });
        });

        if (nextProps.saveSuccessful && !this.hasCountryChanged && !this.hasStateChanged && !this.hasProductChanged) {
            this.allowBack = true;
            this.props.showToast(
                this.props.intl.formatMessage(messages.defaultCoursesSaved, { country: this.country }),
                'success'
            );
        } else if (saveSuccessful !== null && !saveSuccessful) {
            this.allowBack = false;
            this.props.showToast(
                this.props.intl.formatMessage(messages.defaultCoursesFailure, { country: this.country }),
                'error'
            );
        }
    }

    getYearGroup(selectedCountry) {
        if (selectedCountry) {
            this.years = selectedCountry.yearGroups.map(year => ({
                id: year.yearGroupEnum.toString(),
                value: year.longName
            }));
        }
    }

    handleBackButton() {
        if (this.allowBack) {
            PortalCommunication.navigateToLandingScreen(COURSE_MANAGER_LANDING_SCREEN);
            return;
        }

        this.allowBack = true;
        this.props.showToast(this.props.intl.formatMessage(messages.changeWillBeLost), 'warning');
    }

    onDefaultCourseChange(year, courseName, id) {
        const yearId = year.id;

        if (courseName !== '') {
            const index = this.updatedDefaultCourses.findIndex(course => course.yearGroupEnum === yearId);
            this.updatedDefaultCourses[index] = { yearGroupEnum: yearId, courseId: id };
        }
        this.setDefaultCourse(yearId, courseName);
        if (this.updatedDefaultCourses.length) {
            this.isSaved = false;
        } else {
            this.isSaved = true;
        }
        this.allowBack = false;
    }

    setDefaultCourse(yearId, courseName) {
        this.defaultCourses[yearId] = this.defaultCourses[yearId] || {};
        this.defaultCourses[yearId].name = courseName;
        this.setState({ defaultCourses: this.defaultCourses });
    }

    checkForUnsavedChanges() {
        if (!this.isSaved) {
            this.isSaved = true;
            this.props.showToast(this.props.intl.formatMessage(messages.unsavedChanges), 'warning');
            return true;
        }
        return false;
    }

    setCountry(name, value) {
        if (this.checkForUnsavedChanges()) {
            return;
        }
        this.updatedDefaultCourses = [];

        const selectedCountry = this.props.countries.items.find(country => country.code === value);
        this.getYearGroup(selectedCountry);

        this.country = selectedCountry && selectedCountry.name;
        this.selectedCountry = value;
        this.setState({
            filters: {
                defaultCountry: this.selectedCountry
            }
        });

        this.props.getCoursesRequest(this.accessStatus, value, this.state.selectedState, this.state.productId);
        this.setState({ filteredCourses: this.props.genericCourses });
        this.hasCountryChanged = true;
        this.handleOnStateSelect(null, '');
    }

    handleOnProductSelect(name, productId) {
        if (this.checkForUnsavedChanges()) {
            return;
        }

        this.updatedDefaultCourses = [];

        this.setState({ productId });

        this.hasProductChanged = true;
        this.props.getDefaultCourses(productId);
        this.props.getCoursesRequest(this.accessStatus, this.selectedCountry, this.state.selectedState, productId);
    }

    handleOnStateSelect(name, selectedState) {
        this.hasStateChanged = true;
        this.accessStatus = selectedState === '' ? COUNTRY_ACCESS_STATUS : STATE_ACCESS_STATUS;

        if (this.checkForUnsavedChanges()) {
            return;
        }

        this.updatedDefaultCourses = [];

        this.setState({ selectedState });

        this.props.getCoursesRequest(this.accessStatus, this.selectedCountry, selectedState, this.state.productId);
    }

    handleOnSave() {
        this.hasStateChanged = false;
        this.hasCountryChanged = false;
        this.hasProductChanged = false;
        this.allowBack = true;
        this.props.saveDefaultCoursesRequest(this.accessStatus, this.selectedCountry, this.state.selectedState, this.state.productId, this.updatedDefaultCourses);
    }

    render() {
        const countriesList = memoizeOne(countries => countries);
        const { countries } = this.props;
        const { defaultCountry } = this.state.filters;
        const { filteredCourses, defaultCourses, productId, selectedState } = this.state;

        return (
            <SetDefaultCoursesWrapper>
                <Header
                    subtitle={this.props.intl.formatMessage(messages.setDefault)}
                    title={this.props.intl.formatMessage(messages.title)} />
                <DefaultCourses
                    countries={countriesList(countries)}
                    defaultCountry={defaultCountry}
                    defaultCourses={defaultCourses}
                    handleBackButton={this.handleBackButton}
                    handleOnSave={this.handleOnSave}
                    handleOnStateSelect={this.handleOnStateSelect}
                    isSaved={this.isSaved}
                    onDefaultCourseChange={this.onDefaultCourseChange}
                    products={this.products}
                    selectedProductId={productId}
                    selectedState={selectedState}
                    setCountry={this.setCountry}
                    setProduct={this.handleOnProductSelect}
                    {...this.props}
                    courses={filteredCourses}
                    years={this.years} />
            </SetDefaultCoursesWrapper>
        );
    }
}

function mapStateToProps(state) {
    return {
        countries: state.masterCourse.countries,
        years: state.setDefaultCourse.years,
        defaultCourses: state.setDefaultCourse.defaultCourses,
        genericCourses: state.defaultCourse.genericCourses,
        dataSaved: state.setDefaultCourse.dataSaved,
        saveSuccessful: state.setDefaultCourse.saveSuccessful
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getMasterCoursesCountries,
        getCoursesRequest,
        getDefaultCourses,
        saveDefaultCoursesRequest,
        showToast
    }, dispatch);
}

const SetDefaultCoursesWithLoader = withLoader('fetching')(SetDefaultCourses);
export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(SetDefaultCoursesWithLoader));



// WEBPACK FOOTER //
// ./app/containers/set-default-courses/index.js